const Constantes = {
    URL_API: process.env.VUE_APP_RUTA_API,
    URL_LAYOUT: process.env.VUE_APP_RUTA_LAYOUT
};
export default Constantes;